import React, { FC, useState, memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { areEqual } from "Utils/areEqual";
import SingleDestination from "Components/SingleDestination";
import { setSelectedDestinations } from "Containers/Destinations";
import { setStopState, setCurrentStop, StopState } from "Containers/Stops";
import { stopChangeTrigger } from "Containers/Stops/currentStop.Actions";
import {
  setDestinationsViewTrigger,
  SetDestinationsViewTriggerType,
} from "Containers/Destinations/actions";

interface Props {
  destination: any;
  selected: boolean;
  showHideList: (trigger: SetDestinationsViewTriggerType) => void;
  googleMap: any;
}

const SingleDestinationContainer: FC<Props> = memo(
  ({ destination, showHideList, selected = false, googleMap }: Props) => {
    const [hover, setHover] = useState(false);
    const dispatch = useDispatch();
    const stops = useSelector(
      ({ stops: stopsList }: any) => stopsList,
      areEqual
    );

    const { openCount } = useSelector(
      (selectors: any) => selectors.destinations
    );

    const changeHover = useCallback(() => setHover(!hover), [hover]);

    const bottomStopNavTitle = document.getElementById("bottomNavTitle");
    if (bottomStopNavTitle) bottomStopNavTitle.focus();

    const handleClick = useCallback(() => {
      const { id } = destination;

      dispatch(setSelectedDestinations(destination.photoThumb));
      // Store the current stop in Redux. It will be used in the Destinations container
      dispatch(setCurrentStop(id, stopChangeTrigger.DESTINATION_LIST));

      // Select the destination on the map
      dispatch(setStopState([id], StopState.Selected));

      if (showHideList) {
        showHideList(setDestinationsViewTrigger.DESTINATION_CLICK);
      }

      // eslint-disable-next-line no-undef
      const latLng = googleMap.isCustomTiledMap
        ? new window.google.maps.LatLng(
            destination.customLat,
            destination.customLng
          )
        : new window.google.maps.LatLng(
            destination.realLat,
            destination.realLng
          );

      googleMap.panTo(latLng);
    }, [destination, dispatch, googleMap, showHideList]);

    return (
      <SingleDestination
        destination={destination}
        selected={selected}
        changeHover={changeHover}
        hover={hover}
        click={handleClick}
        stops={stops}
        openCount={openCount}
      />
    );
  },
  areEqual
);

export default SingleDestinationContainer;
